

import { BreakpointObserver } from '@angular/cdk/layout';
import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogModule } from '@angular/material/dialog';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatTable, MatTableDataSource, MatTableModule } from '@angular/material/table';
import { AccionesDialog } from '@models/base/identificadores.model';
import { SnackBarService } from '@services/snackBar/snack-bar-service.service';
import { DialogDeleteComponent } from 'src/app/component/dialog-delete/dialog-delete.component';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { isFalsy } from 'utility-types';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatNativeDateModule, MatRippleModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSliderModule } from '@angular/material/slider';
import { MatTooltipModule } from '@angular/material/tooltip';
import { AppRolesDirective } from '@directives/appRoles/app-roles.directive';
import { ButtonNewComponent } from 'src/app/component/button-new/button-new.component';
import { SinDatosParaMostrarComponent } from 'src/app/component/sin-datos-para-mostrar/sin-datos-para-mostrar.component';
import { ButtonFilterTableComponent } from 'src/app/component/button-filter-table/button-filter-table.component';
import { MatSelectModule } from '@angular/material/select';
import { MatRadioModule } from '@angular/material/radio';
import { A11yModule } from '@angular/cdk/a11y';
import { DialogParams } from 'src/app/interfaces/dialogParam.interface.model';
import { AvatarInicialesComponent } from 'src/app/component/avatar-iniciales/avatar-iniciales.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { BuscarExpedienteComponent } from '@views/busquedas/buscar-expediente/buscar-expediente.component';
import { ButtonFilterTableClearComponent } from 'src/app/component/button-filter-table-clear/button-filter-table-clear.component';
import { JuzgadoDto } from '@models/juzgado/juzgadoDto.model';
import { JuzgadoService } from '@services/juzgado/juzgado.service';
import { JuzgadoFilter } from '@models/juzgado/juzgadoFilter.model';
import { DialogFormJuzgadoComponent } from '../dialog-form-juzgado/dialog-form-juzgado.component';
import { JuridiccionService } from '@services/juridiccion/juridiccion.service';
import { FueroService } from '@services/fuero/fuero.service';
import { BrowserModule } from '@angular/platform-browser';
import { BaseDto } from '@models/base/baseDto.model';


@Component({
  standalone: true,
  imports: [SinDatosParaMostrarComponent, ButtonNewComponent, MatFormFieldModule, MatInputModule, ReactiveFormsModule, MatCardModule, MatIconModule, MatButtonModule,
    MatDividerModule, NgxSpinnerModule, MatTableModule,
    MatSliderModule, MatSlideToggleModule, MatMenuModule,
    MatDialogModule, MatDatepickerModule, MatExpansionModule,
    FormsModule, AppRolesDirective, MatTooltipModule, MatSortModule,
    MatPaginatorModule, MatRippleModule, CommonModule, ButtonFilterTableComponent, MatNativeDateModule, MatSelectModule, MatRadioModule, A11yModule, MatCheckboxModule, AvatarInicialesComponent, BuscarExpedienteComponent, ButtonFilterTableClearComponent],
  selector: 'app-list-juzgado',
  templateUrl: './list-juzgado.component.html',
  styleUrls: ['./list-juzgado.component.css']
})



export class ListJuzgadosComponent {

  accionesDialog = AccionesDialog;
  @Input() idExpediente!: number
  data = false
  displayedColumns: string[] = [];
  dataSource = new MatTableDataSource<JuzgadoDto>();
  formBuilder = new FormBuilder
  formFilter!: FormGroup;
  checkedFiltroAvanzado: boolean = false;
  tiposjuzgado!: BaseDto[];
  estadosjuzgado!: BaseDto[];
  expedienteDto: any;
  @ViewChild(MatTable, { static: true }) table!: MatTable<any>;
  jurisdicciones!: BaseDto[];
  fueros!: BaseDto[];
  sort!: MatSort;
  paginator!: MatPaginator;
  @ViewChild(MatSort) set matSort(ms: MatSort) {
    this.sort = ms;
  }

  @ViewChild(MatPaginator) set matPaginator(mp: MatPaginator) {
    this.paginator = mp;
  }
  constructor(
    private juzgadoService: JuzgadoService,
    private juridiccionService: JuridiccionService,
    private fueroService: FueroService,
    private snackBar: SnackBarService,
    private spinner: NgxSpinnerService,
    private breakpointObserver: BreakpointObserver,
    private dialog: MatDialog,
  ) {

    this.getAllFueros()
    this.getAllJurisdicciones()

    this.formFilter = this.formBuilder.group({
      Nombre: [null],
      Telefono: [null],
      Correo: [null],
      Domicilio: [null],
      Localidad: [null],
      IdsFuero: [null],
      IdsJurisdiccion: [null],
      TieneMesaVirtual: [false],
      EsActivo: [true],
      EsSecretaria: [false],
      Nominacion: [null],
      FechaAltaDesde: [null],
      FechaAltaHasta: [null],
    });

    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    this.dataSource.sortingDataAccessor = (item: any, property: string) => {
      switch (property) {
        case 'nombre':
          return item.nombre ?? ''; // Maneja null/undefined

        case 'domicilio':
          return item.domicilio?.toLowerCase?.() ?? '';

        case 'correo':
          return item.correo?.toLowerCase?.() ?? '';

        case 'telefono':
          return item.telefono?.toLowerCase?.() ?? '';

        case 'jurisdiccion':
          return item.jurisdiccion?.descripcion?.toLowerCase?.() ?? '';

        case 'fuero':
          return item.fuero?.descripcion?.toLowerCase?.() ?? '';

        default:
          return typeof item[property] === 'string'
            ? item[property].toLowerCase()
            : item[property] ?? '';
      }
    };

  }



  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  guardarFiltro() {
    const filtro: JuzgadoFilter = this.formFilter.value;
    localStorage.setItem('filtroJuzgadoGuardado', JSON.stringify(filtro));
  }


  limpiarFiltro() {
    this.formFilter.reset();
    localStorage.removeItem('filtroJuzgadoGuardado');
  }


 applyFilter(event: any) {
    if (event) {
      const filterValue = (event.target as HTMLInputElement).value;
      this.dataSource.filter = filterValue.trim().toLowerCase();
    }

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  ngOnInit(): void {

    this.breakpointObserver.observe(['(max-width: 600px)']).subscribe(result => {
      if (this.idExpediente) {
        this.displayedColumns = result.matches ?
          ['nombre', 'accion'] :
          ['nombre', 'domicilio', 'correo', 'telefono', 'jurisdiccion', 'fuero', 'estados', 'accion'];
      } else {
        this.displayedColumns = result.matches ?
          ['nombre', 'accion'] :
          ['nombre', 'domicilio', 'correo', 'telefono', 'jurisdiccion', 'fuero', 'estados', 'accion'];

      }
    });

    const filtroJuzgadoGuardado = localStorage.getItem('filtroJuzgadoGuardado');
    if (filtroJuzgadoGuardado) {
      const filtro: JuzgadoFilter = JSON.parse(filtroJuzgadoGuardado);
      this.formFilter.patchValue(filtro);
    }


  }

  setDataSourceAttributes() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;

    if (this.paginator && this.sort) {
      this.applyFilter(null);
    }
  }

  selectExpediente($event: any) {
    this.expedienteDto = $event
    this.idExpediente = this.expedienteDto.id
    this.formFilter.controls['IdExpediente'].setValue(this.expedienteDto.id);
  }



  filtrosAvanzados(event: any) {
    if (event.checked == true)
      this.checkedFiltroAvanzado = true
    else
      this.checkedFiltroAvanzado = false
  }

  aplicarFiltro(filtro: JuzgadoFilter = this.formFilter.value) {

    this.getAllByFilter(filtro);
    this.guardarFiltro();
  }


  getAllByFilter(filtro: JuzgadoFilter) {
    this.spinner.show('spJuzgado')
    this.juzgadoService.getAllByFilter(filtro)
      .subscribe(
        data => {
          this.spinner.hide('spJuzgado')
          this.dataSource.data = data
          this.data = this.dataSource.data.length >= 1 ? true : false
        },
        error => {
          this.spinner.hide('spJuzgado')
          this.snackBar.showError(error, "Error");
        })
  }


  openDialog<T>(params: DialogParams<T>) {
    const { accion, entidad } = params;

    const data = {
      ...entidad,
      accion,
      idExpediente: this.idExpediente
    };

    const dialogConfig = new MatDialogConfig();
    dialogConfig.autoFocus = false
    dialogConfig.data = data

    switch (accion) {
        case AccionesDialog.Ver:
          dialogConfig.width = "70%"
          break;

        default:
          dialogConfig.width = "50%"
          break;
      }

    const dialogRef = this.dialog.open(DialogFormJuzgadoComponent, dialogConfig);

    dialogRef.afterClosed().subscribe(result => {
      if (!result || !result.event) return;

      switch (result.event) {
        case AccionesDialog.Agregar:
          this.aplicarFiltro()
          break;
        case AccionesDialog.Modificar:
          this.aplicarFiltro()
          break;
        case AccionesDialog.Eliminar:
          this.aplicarFiltro()
          break;
        default:

          break;
      }

    });
  }

  getAllJurisdicciones() {
    this.spinner.show('spJurisdicciones')
    this.juridiccionService.getAll()
      .subscribe(
        data => {
          this.spinner.hide('spJurisdicciones')
          this.jurisdicciones = data
        },
        error => {
          this.spinner.hide('spJurisdicciones')
          this.snackBar.showError(error, "Error");
        })
  }

  getAllFueros() {
    this.spinner.show('spFueros')
    this.fueroService.getAll()
      .subscribe(
        data => {
          this.spinner.hide('spFueros')
          this.fueros = data
        },
        error => {
          this.spinner.hide('spFueros')
          this.snackBar.showError(error, "Error");
        })
  }


  isFalsy(valor: any) {
    return isFalsy(valor)
  }

  trackByItems(index: number, item: any): any { return item; }
}
